import { Box, Card, CircularProgress, Typography } from '@mui/material'
import { EthAccountButton, useNavigateToEthAddress } from '@xylabs/sdk-react'
import { useContext } from 'react'

import ComponentSize from '../../../ComponentSize'
import { EntityContext } from '../../../Contexts'

interface Props {
  onClick?: (event: React.MouseEvent) => void
  page?: string
  size?: ComponentSize
  to?: string
}

const sizeToPixels: Record<ComponentSize, number> = {
  large: 512,
  medium: 384,
  small: 256,
  xlarge: 1024,
  xsmall: 128,
}

const EntityCard: React.FC<Props> = (props) => {
  const { onClick, to, page = 'entity', size = 'medium' } = props
  const entity = useContext(EntityContext)
  const { navigateToEthAddress } = useNavigateToEthAddress()

  const pixelSize = sizeToPixels[size]

  if (entity) {
    const { address } = entity

    const onClickLocal = (event: React.MouseEvent) => {
      event.stopPropagation()
      if (onClick) {
        onClick(event)
      } else {
        navigateToEthAddress(address, event, page, to)
      }
    }

    return (
      <Box
        component={Card}
        display="flex"
        flexDirection="column"
        height={pixelSize}
        onClick={onClickLocal}
        style={{ cursor: 'pointer' }}
        width={pixelSize}
      >
        <Box display="flex" height={pixelSize} justifyContent="center" position="relative">
          <Box
            alignItems="center"
            display="flex"
            justifyContent="center"
            position="absolute"
            style={{ borderBottomLeftRadius: 5, borderBottomRightRadius: 5 }}
            top={0}
          >
            {address ? (
              <EthAccountButton variant="outlined" address={address} />
            ) : (
              <Box paddingX={2}>
                <Typography variant="caption"> - -</Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    )
  }
  return (
    <Box alignItems="center" component={Card} display="flex" height={pixelSize} justifyContent="center" width={pixelSize}>
      <CircularProgress size={24} />
    </Box>
  )
}

export default EntityCard
